module.exports = "/_next/static/images/row2-1-2x-2a372bdf3a89df296fdec11170b07c00.png";